var $ = require('jQuery');
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');
const Vue = require("vue");
const SavedViewsShortcutsBar = require("./../search/components/SavedViewsShortcutsBar").default;
const store = require('@/lib/store').default;

module.exports = function()
{
    new IndexView();
    new Columnator();

    // Score set selector
    $('#scoreSetSelector').on("change", function() {
        var data = 'score-set=' + $(this).val();
        var url  = $(this).data('url');
        $.pjax({url: url, data: data, container: '#pjaxContainer', method: 'GET'});
    });

    const savedViewsShortcutsBar = document.getElementById('saved-views-shortcuts-bar');
    if (savedViewsShortcutsBar) {
        new Vue({
            el: savedViewsShortcutsBar,
            components: {
                'saved-views-shortcuts-bar': SavedViewsShortcutsBar
            },
            store
        });
    }
};
